import { bl_fi_budget_generic_doc_hdr_RowClass } from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";

export class BudgetGenericDocHdrContainerModel extends BaseContainerModel {

  bl_fi_budget_generic_doc_hdr: bl_fi_budget_generic_doc_hdr_RowClass = new bl_fi_budget_generic_doc_hdr_RowClass();
}
